import { useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';

import { getCustomFieldOptionsKey } from '~/constants/react-query-keys';
import { ONE_HOUR } from '~/constants/unitsOfTime';

type UseGetPublicCustomFieldOptionsParams = {
  customFieldId?: string;
  enabled?: boolean;
};

export const useGetPublicCustomFieldOptions = ({ customFieldId, enabled }: UseGetPublicCustomFieldOptionsParams) => {
  const { shortId } = useShortIdContext();

  return useQuery({
    queryKey: getCustomFieldOptionsKey(customFieldId),

    queryFn: () => {
      if (!customFieldId) {
        throw new Error('No custom field id');
      }

      return ShortUrl.listCustomFieldValues(shortId, customFieldId);
    },
    enabled: !!customFieldId && enabled,
    staleTime: ONE_HOUR,
  });
};
